"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_without_1 = __importDefault(require("lodash.without"));

function without(collection, values) {
  return lodash_without_1.default(collection, values);
}

exports.without = without;